import { CloseIcon } from 'assets/icons/CloseIcon'
import { Modal } from 'components/Modal/Modal'
import useModalClose from 'hooks/useModalClose'
import { Button, CursorPointer, Flex } from 'styling/GlobalStyles'
import { BodyText, OtherText, TitleText } from 'styling/Typography'
import { Card, CardBody } from 'components/Card/Card'
import { IKitchenMenuTemplate } from 'types/kitchen/kitchenMenu.interface'
import { KITCHEN_WINDOWS } from '../kitchenData'

interface IProps {
  templates: { [id: number]: IKitchenMenuTemplate }
  closeModal: () => void
  onEdit: (template: IKitchenMenuTemplate) => void
  onNew: () => void
}

export const MenuTemplatesModal = ({ templates, closeModal, onEdit, onNew }: IProps) => {
  useModalClose(closeModal)

  return (
    <Modal black width='560px'>
      <Flex column gap='1rem' width='100%'>
        <Flex between width='100%' center>
          <TitleText weight='bold'>Menu Cycle Templates</TitleText>
          <CursorPointer onClick={closeModal}>
            <CloseIcon />
          </CursorPointer>
        </Flex>
        {Object.values(templates).map((t) => (
          <Card key={t.id}>
            <CardBody>
              <Flex between center width='100%'>
                <Flex column gap='0.25rem'>
                  <BodyText weight='700'>{t.name}</BodyText>
                  <OtherText grey>
                    {t.length}-day cycle · {Object.keys(t.cycle[KITCHEN_WINDOWS[0]] || {}).join(', ')}
                  </OtherText>
                </Flex>
                <Button orangeBorder onClick={() => onEdit(t)}>
                  Edit
                </Button>
              </Flex>
            </CardBody>
          </Card>
        ))}
        <Flex between center width='100%' wrap gap='0.75rem'>
          <OtherText grey>
            Templates are patterns: day-in-cycle × window × tag set → dish. No dates, no quantities, no publication.
          </OtherText>
          <Button orange onClick={onNew}>
            New Template
          </Button>
        </Flex>
      </Flex>
    </Modal>
  )
}
